import Content from "uxp-documentation/src/pages/uxp-api/reference-css/Pseudo-elements/before";
import * as React from 'react';
export default {
  Content,
  React
};